<template>
  <button
    :class="['favourite-icon', { 'icon-large': large }, { active: status }]"
    :aria-label="status ? 'Удалить из избранного' : 'Добавить в избранное'"
    @click.stop="favouritesStore.toggleFavourites(id)"
  >
    <Icon v-if="large" icon="heart-large" />
    <Icon v-else="large" icon="heart" />
    <!-- <Icon v-else icon="trash" /> -->
  </button>
</template>

<script>
export default {
  inject: ["favouritesStore"],
  props: {
    id: {
      type: Number,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    status() {
      return this.favouritesStore.state.favourites.indexOf(this.id) !== -1;
    },
  },
};
</script>

<style scoped>
.favourite-icon {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 1px 0 0;
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  transition: background-color 0.1s, border-color 0.1s;
  appearance: none;
}

.icon-large {
  padding: 0;
  border: none;
}
.icon-large svg{
  margin: 0;
  width: 34px;
  height: 30px;
  fill: white;
  stroke: #FF0020;
}
.icon-large.active svg{
  fill: #FF0020;
}

.favourite-icon .icon-heart,
.favourite-icon .icon-heart-large {
  transition: fill 0.1s, stroke 0.1s;
}

.favourite-icon.active {
  /* padding-top: 0; */
  /* border-color: #FF0020;
  background: #FF0020; */
}

.favourite-icon.active > .icon-heart {
  padding-top: 0;
  /* border-color: #FF0020;
  background: #FF0020; */
  fill: #FF0020;
}

body.-notouch .favourite-icon:hover {
  /* border-color: #FF0020; */
}

body.-notouch .favourite-icon:active > .icon-heart {
  /* border-color: #FF0020; */
  fill: #FF0020;
}

body.-notouch .favourite-icon.active:hover {
  /* border-color: #FF0020;
  background-color: #FF0020; */
}

body.-notouch .favourite-icon.active:active {
  /* border-color: #FF0020;
  background-color: #FF0020; */
}
</style>
